const RESOLVER_ROUTE_EXACT = '/';
const RESOLVER_ROUTE_PREFIX = '/next-step';

/**
 * `/vehicle/{id}` resolves and redirects; every other `vehicle/*` route is a real page whose
 * header carries the only SAVE_EXIT affordance a native webview has. Match the bare numeric id
 * only — never the whole subtree.
 */
const VEHICLE_RESOLVER_ROUTE = /^\/vehicle\/\d+\/?$/;

export const isResolverRoute = (pathname: string) =>
  pathname === RESOLVER_ROUTE_EXACT ||
  pathname.startsWith(RESOLVER_ROUTE_PREFIX) ||
  VEHICLE_RESOLVER_ROUTE.test(pathname);
